var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16986_21573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1409 10.5934C13.7168 11.5964 13.0534 12.4802 12.2088 13.1676C11.3642 13.855 10.3641 14.325 9.29588 14.5366C8.22766 14.7481 7.12387 14.6948 6.08102 14.3813C5.03817 14.0677 4.088 13.5034 3.3136 12.7378C2.5392 11.9722 1.96413 11.0286 1.63868 9.98935C1.31322 8.95015 1.24729 7.84704 1.44665 6.77647C1.64601 5.70591 2.10458 4.70047 2.78228 3.84807C3.45998 2.99567 4.33617 2.32226 5.33425 1.88672",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.26628C14.6667 7.3908 14.4942 6.52389 14.1592 5.71505C13.8242 4.90622 13.3331 4.17129 12.714 3.55223C12.095 2.93317 11.3601 2.44211 10.5512 2.10708C9.74239 1.77205 8.87548 1.59961 8 1.59961V8.26628H14.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.94c11e2825d810cc01d96c1123829678.svg";
export { ForwardRef as ReactComponent };